import { EngagementTriggerQuestion } from '../questions/engagement-trigger.js';
import { ThankYouMessageQuestion } from '../questions/thank-you-message.js';
import { LongTextQuestion } from '../questions/long-text.js';
import { ShortTextQuestion } from '../questions/short-text.js';
import { SingleSelectQuestion } from '../questions/single-select.js';
import { MultiSelectQuestion } from '../questions/multi-select.js';
import { RatingScaleQuestion } from '../questions/rating-scale.js';
import { NPSQuestion } from '../questions/nps.js';
import { RankingQuestion } from '../questions/ranking.js';
import { MatrixQuestion } from '../questions/matrix.js';
import { MailingQuestion } from '../questions/mailing.js';
import { EmojiQuestion } from '../questions/emoji.js';

export function createQuestion(questionData, ctx) {
    switch (questionData.type) {
        case 'Engagement Trigger':
            return new EngagementTriggerQuestion(questionData, ctx);
        case 'Thank You Message':
            return new ThankYouMessageQuestion(questionData, ctx);
        case 'Long Free Text':
            return new LongTextQuestion(questionData, ctx);
        case 'Short Free Text':
            return new ShortTextQuestion(questionData, ctx);
        case 'Single Select':
            return new SingleSelectQuestion(questionData, ctx);
        case 'Multi Select':
            return new MultiSelectQuestion(questionData, ctx);
        case 'Rating Scale':
        case 'CSAT':
        case 'Customer Effort Score':
        case 'CES':
            return new RatingScaleQuestion(questionData, ctx);
        case 'Net Promoter Score':
            return new NPSQuestion(questionData, ctx);
        case 'Ranking':
            return new RankingQuestion(questionData, ctx);
        case 'Matrix':
            return new MatrixQuestion(questionData, ctx);
        case 'Mailing':
            return new MailingQuestion(questionData, ctx);
        case 'Emojis':
            return new EmojiQuestion(questionData, ctx);
        default:
            return null;
    }
}
